// extracted by mini-css-extract-plugin
export var sectionWrapper = "landing-video-module--section-wrapper--Bv-vD";
export var sectionContainer = "landing-video-module--section-container--yvv2V";
export var subtitleBottom = "landing-video-module--subtitle-bottom---J7Uf";
export var videoWrapper = "landing-video-module--video-wrapper--7XMDH";
export var video = "landing-video-module--video--IzILC";
export var videoInnerWrapper = "landing-video-module--video-inner-wrapper--8YNkq";
export var videoFrame = "landing-video-module--video-frame--rYPdB";
export var maskOverlay = "landing-video-module--mask-overlay--2cQxC";
export var playButton = "landing-video-module--play-button--WIqQ5";
export var modalWrapper = "landing-video-module--modal-wrapper--SkDTu";
export var closeIcon = "landing-video-module--close-icon---XOyC";
export var modalVideoFrame = "landing-video-module--modal-video-frame--2x9+b";
export var heroCtaButton = "landing-video-module--hero-cta-button--9zSPw";
export var mediaWrapper = "landing-video-module--media-wrapper--RsQ-A";
export var mediaWrapperModal = "landing-video-module--media-wrapper-modal--woJbP";
export var contentWrapper = "landing-video-module--content-wrapper--Fog9T";